<template>
  <div class="view contentBody">
    <div class="content">
      <div class="content-tab-box">
        <span :class="meaulistTab.firstTab==item?'content-tab-box-active':''" @click="tabCurrentFn(item)"
              v-for="(item,index) in meaulistTab.tab" :key="item">{{index}}</span>
      </div>
      <div v-for="item in meaulistTab.tab" :key="item">
        <component v-bind:is="item" v-if="meaulistTab.firstTab==item"></component>
      </div>
    </div>
  </div>
</template>
<script>
  import commissionSetting from "./commissionSetting.vue";
  import personalCommission from "./personalCommission.vue";
  import employeeCommission from "./employeeCommission.vue";
  import withdrawalReview from "./withdrawalReview.vue";

  let tabBox = {
    '个人佣金': {property: 'personalCommission'},
    '员工佣金': {property: 'employeeCommission'},
    '提现审核': {property: 'withdrawalReview'},
    '佣金设置': {property: 'commissionSetting'}
  }
  export default {
    name: "commissions",
    components: {
      commissionSetting,
      personalCommission,
      employeeCommission,
      withdrawalReview
    },
    
    data() {
      return {
        meaulistTab: this.meaulist.meaulistGet(this, tabBox),
        activeName: ""
      };
    },
    created() {
      this.inittab();
    },
    methods: {
      inittab() {
        this.activeName =
            this.$route.query.tab !== undefined
                ? this.$route.query.tab
                : "personalCommission";
      },
      tabCurrentFn(index) {
        this.meaulistTab.firstTab = index
      }
    }
  };
</script>
